import ProjectService from '../services/project.service.js'
import UserService from '../services/user.service.js'




export default class versionManagementService {

    getVersionsList = function (self, token) {

        if (self.$route.params.projectId) {
            let Pservice = new ProjectService();
            let Uservice = new UserService();

            Pservice.getVersionsList(token, self.$route.params.projectId)
                .then((versions) => {
                    versions.forEach((version) => {
                        let date = new Date(version.createdDate);
                        let versionItem =
                        {
                            videoTitle: version.videoTitle,
                            publisher: version.publisher,
                            description: version.description,
                            date: date.getDate() +
                                "/" +
                                (date.getMonth() + 1) +
                                "/" +
                                date.getFullYear(),

                            versionGen: version.number,
                        }

                        if (version.deleted)
                            versionItem.deleted = true;
                        else
                        {
                            versionItem.deleted = false;
                            self.numberVersion++;
                        }

                        if (version.publisher !== undefined)
                            versionItem.publisherInitials = (version.publisher[0] + version.publisher[1]).toUpperCase();
                        else
                            versionItem.publisherInitials = "UN";

                        if (!version.deleted)
                            Uservice.getUser(self.$auth.token(), version.publisher)
                                .then((user) => {
                                    versionItem.publisherColor = "#" + user.color;
                                    self.versionsList = self.versionsList.splice(0);
                                }).catch(error => {
                                })

                        self.versionsList.push(versionItem);
                    })

                    self.versionsList.sort((a, b) => a.versionGen - b.versionGen);

                })


            // let url = "/a/project/" + self.$route.params.projectId + "/versions";
            // fetch(url).then((res) => {
            //     if (res.status === 200) {
            //         res.json().then((versionsList) => {
            //             versionsList.forEach((version) => {
            //                 // Récupérer les initiales du publisher
            //                 // Pour l'instant on affichera l'id du publisher
            //                 // On crée l'objet à mettre dans la liste
            //                 let date = new Date(version.date);
            //                 version.publisher.initials = (version.publisher.firstname[0] + version.publisher.lastname[0]).toUpperCase();
            //                 version.publisher.color = "#" + version.publisher.color;
            //                 console.log("PUBLISHER: " + JSON.stringify(version.publisher));
            //                 let versionItem = {
            //                     publisher: version.publisher,
            //                     description: version.description,
            //                     date:
            //                         date.getDate() +
            //                         "/" +
            //                         (date.getMonth() + 1) +
            //                         "/" +
            //                         date.getFullYear(),
            //                     versionGen: version.versionGen,
            //                     versionVariante: version.versionVariante,
            //                 };
            //                 self.versionsList.push(versionItem);
            //             });
            //         });
            //     }
            // });
        }
    }

    getVersionVideo = function (self, versionGen) {
        // let theme = self.$vuetify.theme.dark;
        // self.$route.params.versionGen = versionGen;
        self.$router.push("/vireed/" + self.$route.params.projectId + "/" + versionGen);
        // self.$router.push("/");
        // location.reload();
        // console.log(theme);


    };

    deleteVersion = function (self, versionGen, versionVariante) {
        let url =
            "/a/project/" +
            self.$route.params.projectId +
            "/version/" +
            versionGen +
            "?versionVariante=" +
            versionVariante;
        fetch(url, {
            method: "DELETE",
        }).then((res) => {
            if (res.status === 200) {
                getVersionsList();
            }
        });
    }
}

// module.exports = {
//     getVersionsList,
//     getVersionVideo,
//     deleteVersion
// }
